import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-gray-200 bg-gray-50 p-3" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  role: "alert"
}
const _hoisted_3 = {
  key: 1,
  class: "mt-2 text-sm text-gray-500"
}
const _hoisted_4 = {
  key: 2,
  class: "mt-2 text-sm text-gray-500"
}
const _hoisted_5 = {
  key: 3,
  class: "mt-2 divide-y divide-gray-200"
}
const _hoisted_6 = { class: "min-w-0" }
const _hoisted_7 = { class: "truncate text-sm font-medium text-gray-900" }
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = {
  "data-test": "identity",
  class: "text-xs text-gray-500"
}
const _hoisted_10 = {
  key: 4,
  class: "mt-2 text-xs text-gray-500"
}

import { computed, onBeforeUnmount, ref, watch } from 'vue'

import InputField from '@/components/neue/InputField.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import { itemDescription, itemIdentity } from '@/helpers/parsley'
import { errorMessage, parsleyApi } from '@/services/parsleyApi'

const SEARCH_DELAY_MS = 250
const RESULT_LIMIT = 8
const MIN_SEARCH_LENGTH = 2
const SEARCH_ERROR = "Couldn't search Parsley. Please try again."


export default {
  __name: 'ParsleyItemPicker',
  emits: ['select'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const text = ref('')
const items = ref([])
const searching = ref(false)
const searchedFor = ref('')
const error = ref('')
const totalRecords = ref(0)

// Only the first few results are shown, so the merchant is told when there
// are more.
const hasMore = computed(() => items.value.length > 0 && totalRecords.value > items.value.length)
const moreText = computed(
  () => `Showing ${items.value.length} of ${totalRecords.value}. Keep typing to narrow it down.`
)

let timer = null
let latest = 0

const reset = () => {
  // Bumping the counter abandons any search still in flight.
  latest += 1
  items.value = []
  searching.value = false
  searchedFor.value = ''
  error.value = ''
}

const search = async value => {
  const mine = (latest += 1)
  searching.value = true
  error.value = ''
  try {
    const result = await parsleyApi.menuItems({ search: value, active: 'true', page_size: RESULT_LIMIT })
    if (mine !== latest) return
    items.value = result.data
    totalRecords.value = result.total_records ?? 0
    searchedFor.value = value
  } catch (failure) {
    if (mine !== latest) return
    items.value = []
    error.value = errorMessage(failure, SEARCH_ERROR)
  } finally {
    if (mine === latest) searching.value = false
  }
}

watch(text, value => {
  if (timer) clearTimeout(timer)
  const trimmed = String(value ?? '').trim()
  if (trimmed.length < MIN_SEARCH_LENGTH) {
    reset()
    return
  }
  timer = setTimeout(() => search(trimmed), SEARCH_DELAY_MS)
})

onBeforeUnmount(() => {
  if (timer) clearTimeout(timer)
  latest += 1
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InputField, {
      modelValue: text.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((text).value = $event)),
      placeholder: "Search Parsley by name"
    }, null, 8, ["modelValue"]),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(error.value), 1))
      : (searching.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Searching Parsley..."))
        : (searchedFor.value && !items.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " No Parsley items match \"" + _toDisplayString(searchedFor.value) + "\" ", 1))
          : _createCommentVNode("", true),
    (items.value.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: "flex items-center justify-between gap-4 py-2"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.attributes.name), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(itemDescription)(item.attributes)), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(itemIdentity)(item.attributes)), 1)
              ]),
              _createVNode(NeueButton, {
                type: "secondary",
                onClick: $event => (emit('select', item))
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Link", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (hasMore.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(moreText.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}